import React from "react";

const Footer = () => {
  return (
    <footer style={styles.footer}>
      <p>&copy; 2025 Find ID version 1.0.0 Tous droits réservés.</p>
    </footer>
  );
};

const styles = {
  footer: {
    backgroundColor: "black",
    color: "#fff",
    textAlign: "center",
    padding: "10px",
    marginTop: "auto",
    width: "100%"
  }
};

export default Footer;
